import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type CasesTableViewState = {
  searchTerm: string;
  selectedPhysician: string;
  selectedReportType: string;
  pageIndex: number;
  pageSize: number;
  /** Server-side Created At sort. Default newest-first. */
  createdSortOrder: 'ascend' | 'descend';
  selectedSessionId: string | null;
};

const initialState: CasesTableViewState = {
  searchTerm: '',
  selectedPhysician: '',
  selectedReportType: '',
  pageIndex: 1,
  pageSize: 7,
  createdSortOrder: 'descend',
  selectedSessionId: null,
};

export const CasesTableViewStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => {
    return {
      setViewState(viewState: Partial<CasesTableViewState>) {
        patchState(store, viewState);
      },
      reset() {
        patchState(store, initialState);
      },
    };
  }),
);
